"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readableFromWeb = void 0;
var ReadableFromWeb_1 = require("./ReadableFromWeb");
Object.defineProperty(exports, "readableFromWeb", { enumerable: true, get: function () { return ReadableFromWeb_1.readableFromWeb; } });
//# sourceMappingURL=index.js.map